import {
  LaunchdarklyClient,
  LaunchDarklyApiKeys,
  FFUser,
  DEFAULT_SERVER_TIMEOUT,
  wrapWithTimeoutLimit,
} from '@kaltura-ott/tvpil';
import type { LDFlagValue } from '@launchdarkly/js-client-sdk-common';
import { observable } from 'mobx';

export enum FEATURE_ENABLER_VARIATIONS {
  debugLoggerUrl = 'debugLoggerUrl',
  debugCategoryTree = 'debug_category_tree',
  predefinedKsql = 'predefinedKsql',
  refreshDataTTL = 'refreshDataTTL',
}

interface SetupFeatureEnablerProps {
  apiKeys: LaunchDarklyApiKeys;
  data: {
    // @ts-expect-error TODO Fix
    key;
    custom: {
      partnerId: string;
      applicationName: string;
      clientVersion: string;
      tvpilVersion: string;
      clientTag: string;
      release: string;
      deviceBrand: string;
    };
  };
}

export class FeatureEnabler {
  public variations = observable.map<string, LDFlagValue>({});
  private ffClient?: LaunchdarklyClient;
  private ffUser?: FFUser;
  // @ts-expect-error TODO Fix
  private setupProps: SetupFeatureEnablerProps;
  private testVariations = new Map<string, LDFlagValue>();

  public setup(setupProps: SetupFeatureEnablerProps, ffClient: LaunchdarklyClient) {
    this.ffClient = ffClient;
    this.setupProps = setupProps;
  }

  public async init(ffUser: FFUser): Promise<void> {
    try {
      await wrapWithTimeoutLimit(DEFAULT_SERVER_TIMEOUT * 1000, async () => {
        this.ffUser = ffUser;
        const flags = await this.ffClient?.initialize(this.setupProps.apiKeys, ffUser);
        this.variations.merge(flags);
      });
    } catch (e) {
      this.ffClient = undefined;
    }
  }
  public async updateUser(newUser: FFUser, data: Partial<FFUser['custom']> = {}): Promise<void> {
    // @ts-expect-error TODO Fix
    this.ffUser = { ...this.ffUser, ...newUser, custom: { ...this.ffUser.custom, ...data } };
    await wrapWithTimeoutLimit(DEFAULT_SERVER_TIMEOUT * 1000, async () => {
      // @ts-expect-error TODO Fix
      const newFlags = await this.ffClient?.identify(this.ffUser);
      this.variations.merge(newFlags);
    });
  }

  public async updateCustomData(data: Partial<FFUser['custom']>): Promise<void> {
    // @ts-expect-error TODO Fix
    this.ffUser = { ...this.ffUser, custom: { ...this.ffUser?.custom, ...data } };
    // @ts-expect-error TODO Fix
    await this.updateUser({ ...this.ffUser, custom: { ...this.ffUser?.custom, ...data } });
  }

  /**
   * Returns launchdarkly value or default
   *
   * @param key - launchdarkly key
   * @param defaultValue - value for default
   * @param testValue -
   */
  public variation(key: string, defaultValue?: LDFlagValue): LDFlagValue {
    if (this.testVariations.has(key)) {
      return this.testVariations.get(key);
    }

    if (!this.ffClient) {
      return this.setVariation(key, defaultValue);
    }
    const value = this.variations.get(key);
    return this.setVariation(key, value === undefined ? defaultValue : value);
  }

  private setVariation(key: string, value: LDFlagValue): LDFlagValue {
    this.variations.set(key, value);
    return this.variations.get(key);
  }

  /**
   * For the test only. Do not use in clients
   * @param key
   * @param testValue
   */
  // @ts-expect-error TODO Fix
  public setTestData(key: string, testValue) {
    this.testVariations.set(key, testValue);
  }

  /**
   * For the test only. Do not use in clients
   */
  public resetTestData() {
    this.testVariations.clear();
  }
}

export const featureEnabler = new FeatureEnabler();
